module.exports = __webpack_public_path__ + "img/51626512_L.f5b36e5e.png";